






















































































































































































































































































































import { Component, Prop, Vue, Watch, Ref } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import Keluhan from "@/components/pemeriksaan/assesmen/Keluhan.vue";
import RiwayatPenyakit from "@/components/pemeriksaan/assesmen/RiwayatPenyakit.vue";
import Lokalis from "@/components/pemeriksaan/assesmen/asesmenkeperawatan/Lokalis.vue";
import DataAsesmenRalan from "@/services/DataAsesmenRalan";
import { storeAssesmenRalan } from "@/store/modules/asesmenralan";
import Penunjang from "@/components/pemeriksaan/assesmen/Penunjang.vue";
import { appModule } from "@/store/modules/app";
import Editor from "vue-image-markup";
import StatusLokalis from "@/components/pemeriksaan/assesmen/StatusLokalis.vue";
import { storeSoap } from "@/store/modules/soap";
// import CardModalSoap from "@/components/modal/CardModalSoap.vue";
import KasusKronis from "@/components/pemeriksaan/assesmen/KasusKronis.vue";
import DokterAutoComplete from "@/components/pemeriksaan/assesmen/DokterAutoComplete.vue";
import ModalKonfirmasi from "@/components/modal/KonfirmasiLogout.vue";
import RiwayatAsesmenPerawat from "@/components/pemeriksaan/assesmen/RiwayatAsesmenPerawat.vue";
import { storeCopy } from "@/store/modules/copy";
import InterfaceAsesmenRalan from "@/apiInterface/InterfaceAsesmenRalan";

@Component({
  components: {
    Lokalis,
    Keluhan,
    RiwayatPenyakit,
    Penunjang,
    StatusLokalis,
    Editor,
    // CardModalSoap,
    KasusKronis,
    DokterAutoComplete,
    ModalKonfirmasi,
    RiwayatAsesmenPerawat
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardAssesmenDokter extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop() showBtn!: boolean;
  @Prop() showRiwayat!: boolean;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }
  @Ref() readonly editor;
  sess_login = userModule.user;
  getparam = {
    reg: this.register,
    unit_id: this.sess_login.unit_id
  };
  dokter = {};
  asesmenMedis = {
    keluhan_utama_medis: null,
    riwayat_penyakit_sekarang: null,
    penunjang: null,
    diagnosis_medis: null,
    tindakan_medis: null
  };
  status_lokalis = {
    catatan: "",
    gambar: require("@/assets/img/body_w.png")
  };
  labelDiag = null;
  labelTin = null;
  riwayat = null;
  checkKronis = false;
  imageUrl = require("@/assets/img/body_w.png");
  canvasWidth = 700;
  canvasHeight = 440;
  modalOpenKonfirmasi = false;
  modalSoap = false;
  loadingSimpan = false;
  isMounted = false;
  historyCount = 1;
  validasi = [v => !!v || "*Kolom ini harus diisi"];

  mounted() {
    if (this.sess_login.profesi == "Dokter") {
      this.dokter = {
        id: this.sess_login.id,
        nama: this.sess_login.nama
      };
    } else {
      this.dokter = {};
    }

    storeAssesmenRalan.actAsesmenAwal(this.getparam);

    this.editor.getObjectsById("canvasAnatomi");
    // this.editor.set(this.editor.mode, this.editor.options);
    this.editor.setBackgroundImage(this.imageUrl);
    // this.editor.undo();
    // this.clearCanvasHistory();

    // this.isMounted = true;

    // this.clearCanvasHistory();
  }

  logCanvas() {
    console.log(this.history);
  }

  get history() {
    return this.editor.history;
  }

  get disableUndo() {
    return false;
    // if (!this.isMounted) return true;

    // return this.editor.history.length < 2;
  }

  get disableRedo() {
    return false;
    // if (!this.isMounted) return true;

    // if (this.editor.history.length >= this.historyCount) {
    //   this.historyCount = this.editor.history.length;
    //   return true;
    // }

    // return false;
  }

  get statusSubj() {
    return storeCopy.copyS;
  }
  get statusAss() {
    return storeCopy.copyA;
  }
  get statusPlan() {
    return storeCopy.copyP;
  }
  get pasteSubj() {
    return storeCopy.subj;
  }
  get pasteAss() {
    return storeCopy.ass;
  }
  get pastePlan() {
    return storeCopy.plan;
  }

  get statusPasteInstant() {
    return storeCopy.copySoapInstant;
  }

  @Watch("statusPasteInstant")
  changeStatusPasteInstant(val) {
    if (val) {
      const cSoap = storeCopy.pastesoap;

      this.tempelSubj(cSoap["s"]);
      this.tempelAss(cSoap["a"]);
      this.tempelPlan(cSoap["p"]);
      this.setRiwayatPenyakit(
        this.stateAsesmenAwal["riwayat_perawatan_sebelum"]
      );
    }
  }

  saveImage() {
    const x = this.editor.saveImage();
  }

  freeDrawing() {
    const customizeFreeDrawing = { stroke: "black", strokeWidth: 3 };
    this.editor.set("freeDrawing", customizeFreeDrawing);
  }

  helperForTextMode() {
    // helper untuk mengatasi bug text mode fabric js Cannot read properties of undefined (reading 'toLowerCase') at klass.getFontCache
    const opt = {
      overlayOpacity: "0",
      hasControl: false,
      width: 1,
      height: 1
    };
    this.editor.set("crop", opt);
  }

  textMode() {
    this.helperForTextMode();

    const opt = {
      id: "title",
      fill: "black",
      fontFamily: "Verdana",
      fontSize: 13,
      placeholder: "Type something"
    };

    setTimeout(() => {
      this.editor.set("text", opt);
    }, 5);
  }

  selectMode() {
    this.editor.set("selectMode");
  }

  arrowMode() {
    const customizeArrow = { stroke: "black", strokeWidth: 2 };
    this.editor.set("arrow", customizeArrow);
  }

  eraseMode() {
    this.editor.set("eraser");
  }

  undoMode() {
    this.editor.undo();
  }

  clearMode() {
    this.editor.clear();
    this.editor.setBackgroundImage(this.imageUrl);
    // this.clearCanvasHistory();
  }

  redoMode() {
    this.editor.redo();
  }

  clearCanvasHistory() {
    this.editor.history.splice(0);
    this.historyCount = this.editor.history.length;
  }

  setLokalis(v) {
    this.status_lokalis["catatan"] = v;
  }

  setPenunjang(v) {
    this.asesmenMedis["penunjang"] = v;
  }

  setKeluhan(v) {
    this.asesmenMedis["keluhan_utama_medis"] = v;
  }

  setKronis(val) {
    this.checkKronis = val;
  }

  setDokter(val) {
    this.dokter = val;
  }

  get stateAsesmenAwal() {
    return storeAssesmenRalan.asesmenAwal;
  }

  get statesoap() {
    return storeSoap.soapAll;
  }

  setRiwayatPenyakit(v) {
    this.asesmenMedis["riwayat_penyakit_sekarang"] = v;
  }

  @Watch("asesmenMedis.tindakan_medis")
  valTindakan(v) {
    if (v == "") {
      this.labelTin = "";
    } else {
      this.labelTin = "Tindakan dan Terapi";
    }
  }

  @Watch("asesmenMedis.diagnosis_medis")
  valDiagnosis(v) {
    if (v == "") {
      this.labelDiag = "";
    } else {
      this.labelDiag = "Diagnosis";
    }
  }
  @Watch("stateAsesmenAwal")
  valAsesemnMedis(val) {
    if (val == null) {
      console.log("a1");
      console.log("kosong");
      this.asesmenMedis = {
        keluhan_utama_medis: null,
        riwayat_penyakit_sekarang: null,
        penunjang: null,
        diagnosis_medis: null,
        tindakan_medis: null
      };
      this.checkKronis = false;
      this.editor.setBackgroundImage(this.imageUrl);
    } else {
      console.log("a2");
      if (val["dokter"]) {
        this.dokter = val["dokter"];
      }
      if (val["status_lokalis"]) {
        this.status_lokalis = {
          catatan: val["status_lokalis"]["catatan"],
          gambar: val["status_lokalis"]["gambar"]
        };
        this.editor.setBackgroundImage(this.status_lokalis["gambar"]);
      }
      if (val["kronis"] == 1) {
        this.checkKronis = true;
      } else {
        this.checkKronis = false;
      }
      this.asesmenMedis = {
        keluhan_utama_medis: val["keluhan_utama_medis"],
        riwayat_penyakit_sekarang: val["riwayat_penyakit_sekarang"],
        penunjang: val["penunjang"],
        diagnosis_medis: val["diagnosis_medis"],
        tindakan_medis: val["tindakan_medis"]
      };
    }
  }

  simpan() {
    this.loadingSimpan = true;

    let kronis = 0;
    if (this.checkKronis == true) {
      kronis = 1;
    } else {
      kronis = 0;
    }
    const param = {
      keluhan_utama_medis: this.asesmenMedis["keluhan_utama_medis"],
      riwayat_penyakit_sekarang: this.asesmenMedis["riwayat_penyakit_sekarang"],
      status_lokalis: {
        catatan: this.status_lokalis["catatan"],
        // gambar: this.editor.history.length > 1 ? this.editor.saveImage() : null
        gambar: this.editor.saveImage()
      },
      penunjang: this.asesmenMedis["penunjang"],
      diagnosis_medis: this.asesmenMedis["diagnosis_medis"],
      tindakan_medis: this.asesmenMedis["tindakan_medis"],
      kronis: kronis
    };

    if (this.stateAsesmenAwal && this.stateAsesmenAwal["id"]) {
      const dt = DataAsesmenRalan.editDataAsesmenRalanMedis(
        this.stateAsesmenAwal["id"],
        this.register,
        this.rm,
        this.sess_login.unit_id,
        this.dokter["id"],
        param
      );
      dt.then(dt => {
        appModule.setLoading(false);
        if (dt["status"] != 1) {
          // appModule.sendErrorAlert(dt["err"]);
        } else {
          storeAssesmenRalan.actAsesmenAwal(this.getparam);
          appModule.NoticeDelay("Berhasil Update Asesmen Medis");
          if (
            this.statesoap.length == 0 &&
            this.sess_login.profesi == "Dokter"
          ) {
            // this.modalSoap = true;
            // this.modalOpenKonfirmasi = true;
            this.redirectSoap();
          }
        }
      })
        .catch(err => {
          console.log(err);
        })
        .finally(() => (this.loadingSimpan = false));
    } else {
      console.log("simpan");
      const dt = DataAsesmenRalan.saveDataAsesmenRalanMedis(
        this.register,
        this.rm,
        this.sess_login.unit_id,
        this.dokter["id"],
        param
      );
      dt.then(dt => {
        appModule.setLoading(false);
        if (dt["status"] != 1) {
          // appModule.sendErrorAlert(dt["err"]);
        } else {
          storeAssesmenRalan.actAsesmenAwal(this.getparam);
          appModule.NoticeDelay("Berhasil Simpan Asesmen Medis");
          if (
            this.statesoap.length == 0 &&
            this.sess_login.profesi == "Dokter"
          ) {
            // this.modalSoap = true;
            // this.modalOpenKonfirmasi = true;
            this.redirectSoap();
          }
        }
      })
        .catch(err => {
          console.log(err);
        })
        .finally(() => (this.loadingSimpan = false));
    }
  }
  cetak() {
    // const dt = DataAsesmenRalan.getCetakPdfAsesmenAwalRalan(
    //   this.stateAsesmenAwal["id"]
    // );
    // dt.then((dt) => {
    //   window.open(dt, "_blank");
    // });

    // const routeData =
    //   // http.getAPI() +
    //   "http://10.10.187.6/rme/public/api/v1" +
    //   "/asesmen-awal-ralan/" +
    //   this.stateAsesmenAwal["id"] +
    //   "/pdf";
    // window.open(routeData, "_blank");

    InterfaceAsesmenRalan.print(this.stateAsesmenAwal["id"]);
  }

  copyKeluhan(v) {
    if (!this.asesmenMedis.keluhan_utama_medis) {
      this.asesmenMedis.keluhan_utama_medis = v;
    } else {
      appModule.sendErrorAlert(
        "Tidak bisa Copy Keluhan Utama karena sudah ada isian Keluhan Medis yg anda buat"
      );
    }
  }

  // Side-panel "Riwayat Pasien" (Poin 3) — paste Pemeriksaan Fisik dari
  // kunjungan sebelumnya. `seq` di store agar watch terpicu walau value sama.
  get pasteBufferPF() {
    return storeCopy.pastePemeriksaanFisik;
  }

  @Watch("pasteBufferPF")
  applyPastePemeriksaanFisik(payload: any) {
    if (!payload || !payload.value) return;
    const value = String(payload.value).trim();
    if (!value) return;

    if (payload.target === "status_lokalis") {
      const existing = (this.status_lokalis.catatan || "").trim();
      this.status_lokalis.catatan =
        existing && !existing.includes(value)
          ? `${existing}\n${value}`
          : value;
    } else if (payload.target === "penunjang") {
      const existing = (this.asesmenMedis.penunjang || "").trim();
      this.asesmenMedis.penunjang =
        existing && !existing.includes(value)
          ? `${existing}\n${value}`
          : value;
    } else if (payload.target === "tindakan") {
      const existing = (this.asesmenMedis.tindakan_medis || "").trim();
      this.asesmenMedis.tindakan_medis =
        existing && !existing.includes(value)
          ? `${existing}\n${value}`
          : value;
    }
  }

  redirectSoap() {
    this.$emit("isiSoap");
  }

  tempelSubj(v) {
    if (this.asesmenMedis.keluhan_utama_medis) {
      appModule.sendErrorAlert(
        "Sudah ada Keluhan Utama tersedia, tidak bisa menimpa."
      );
    } else {
      this.asesmenMedis.keluhan_utama_medis = v;
      storeCopy.clear_copy_subj();
    }
  }

  tempelAss(v) {
    if (this.asesmenMedis.diagnosis_medis) {
      appModule.sendErrorAlert(
        "Sudah ada Diagnosis tersedia, tidak bisa menimpa."
      );
    } else {
      this.asesmenMedis.diagnosis_medis = v;
      storeCopy.clear_copy_ass();
    }
  }

  tempelPlan(v) {
    if (this.asesmenMedis.tindakan_medis) {
      appModule.sendErrorAlert(
        "Sudah ada Tindakan/Terapi tersedia, tidak bisa menimpa."
      );
    } else {
      this.asesmenMedis.tindakan_medis = v;
      storeCopy.clear_copy_plan();
    }
  }
}
